export default "__VITE_ASSET__DuDHMLvq__"